/** @hidden */
export class ShaderDefineExpression {
    public isTrue(preprocessors: { [key: string]: string }): boolean {
        return true;
    }
}